/**
 * Route for `ccpa-dsr`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CcpaDsrPage } from "../features/ccpa-dsr/CcpaDsrPage";

export const ccpaDsrRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/ccpa-dsr",
	component: CcpaDsrPage,
});

export default ccpaDsrRoute;
